import React from 'react'
import { BsArrowRightCircle } from 'react-icons/bs'
import { rewardsFor } from 'data/service-hub-content'

// Sign-up discount, loyalty points and referral rewards. The same account
// benefits apply to every service, so the copy lives once in data/service-hub-content.js.
export const RewardsSection = ({ serviceNoun, title = 'Discounts & Rewards' }) => (
    <section className='py-10 px-2'>
        <h2 className='text-2xl md:text-3xl text-center uppercase leading-normal font-bold'>
            {title}
        </h2>
        <ul className='max-w-5xl mx-auto grid grid-cols-1 sm:grid-cols-3 gap-3 px-4 pt-5'>
            {rewardsFor(serviceNoun).map(({ title: heading, desc }) => (
                <li key={heading} className='bg-white border border-gray-200 rounded-2xl p-4'>
                    <div className='text-orange-500 text-lg mb-2'><BsArrowRightCircle aria-hidden="true"/></div>
                    <h3 className='text-sm font-bold text-gray-900 mb-1'>{heading}</h3>
                    <p className='text-sm text-gray-600 leading-relaxed'>{desc}</p>
                </li>
            ))}
        </ul>
    </section>
)
